var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selected_option != '')?_c('b-button',{attrs:{"variant":"outline-success","block":""},on:{"click":_vm.back}},[_vm._v(" Volver ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }